import script from "./Delegator.vue?vue&type=script&setup=true&lang=js"
export * from "./Delegator.vue?vue&type=script&setup=true&lang=js"

import "./Delegator.vue?vue&type=style&index=0&id=5c9be170&scoped=true&lang=css"

import exportComponent from "/builds/websites/koch-bus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9be170"]])

export default __exports__